export class MeasureCanvas {
	private canvas: HTMLCanvasElement;
	private context: CanvasRenderingContext2D;

	constructor() {
		this.canvas = document.createElement("canvas");
		this.context = this.canvas.getContext("2d")!;
	}

	public getTextWidth(text: string, font: string): number {
		this.context.font = font;
		return this.context.measureText(text).width;
	}
}
